<script setup>
import transitionConfig from '../../helpers/transitionConfig'
import {getEndpointFromSlug} from '~/globals/globals.js'

definePageMeta({
  pageTransition: transitionConfig,
})

const {locale} = useI18n()
const parser = ParserUtils()
const route = useRoute()
const config = useRuntimeConfig()

// MANAGING NEWS SLUG TRANSLATIONS
let endpointNewsTranslations = config.public.apiBase + locale.value + '/news.json'
// console.log('ENDPOINT NEWS TRANSLATIONS: ', endpointNewsTranslations)
const {fetchedData: fetchedNewsTranslations} = await useDataStatic(endpointNewsTranslations)

const newsTranslations = computed(() => {
  if( fetchedNewsTranslations.value ){
    return parser.getTranslations(fetchedNewsTranslations.value, 'news')
  }
  return null
})

const endpointName = getEndpointFromSlug(newsTranslations?.value, route.params.newsSlug, locale.value)
// console.log('News endpointName: ', endpointName)

// let endpoint =
//   config.public.apiBase +
//   locale.value +
//   '/news/' +
//   route.params.newsSlug +
//   '.json'

let endpoint =
  config.public.apiBase +
  locale.value +
  '/news/' +
  endpointName +
  '.json'
// console.log('ENDPOINT: ', endpoint)

const {fetchedData} = await useDataStatic(endpoint)

const processedData = computed(() => {
  if (fetchedData.value) {
    return parser.newsPage(fetchedData.value)
  }
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
  // return null
})

onMounted(() => {
  useAnimations()
})

useHead({
  title: () =>
    processedData.value?.section.title
      ? `${processedData.value?.section.title}`
      : '',
  meta: [
    {
      name: 'description',
      content: () => `${processedData.value?.section.description}`,
    },
  ],
  bodyAttrs: {
    class: 'page page--news-detail',
  },
})

useSeoMeta({
  ogTitle: () => `${processedData.value?.section.seo.title}`,
  description: () => `${processedData.value?.section.seo.description}`,
  ogDescription: () => `${processedData.value?.section.seo.description}`,
  ogImage: () => `${processedData.value?.section.seo.image}`,
  twitterCard: 'summary_large_image',
})
</script>

<template>
  <div>
    <SharedModulesHero
      v-if="processedData"
      :content="processedData"
      :layout="2"
      :goBack="true" />
    <div class="scroll-target" id="content"></div>
    <!-- <pre>{{ JSON.stringify(processedData, null, 2) }}</pre> -->
    <NewsContent :content="processedData" v-if="processedData" />
    <NewsExtra :content="processedData" v-if="processedData" />
  </div>
</template>

<style lang="scss"></style>
